import { scopedApi } from '@/session/scopedClients';
import type { RequestScope } from '@/session/scopedTransport';
import { DBImportProfile } from '@/types/import';
import { EndpointResponse } from '@/types/endpoints';
import { utils } from '../../utils';
import type { WriteRequestOptions } from '../requestOptions';

const validate = (recurringImportId: number) => {
  if (recurringImportId === undefined || recurringImportId === null) {
    throw new Error('`recurringImportId` is required');
  }
};

type RequestParams = {
  recurringImportId: number;
};

type Response = {
  import_profile: DBImportProfile;
};

export const deleteRecurringImport = async (
  scope: RequestScope,
  { recurringImportId }: RequestParams,
  requestOptions: WriteRequestOptions
): Promise<EndpointResponse<Response>> => {
  try {
    validate(recurringImportId);

    const result = await scopedApi(scope).delete<EndpointResponse<Response>>(`recurring_import/${recurringImportId}`, requestOptions);
    return result.data;
  } catch (e) {
    return utils.error.handleAxiosError(e);
  }
};
